import { isValidPhoneNumber } from "libphonenumber-js/max";

export const isValidPhone = (value?: string) => {
  if (!value) return true;
  return isValidPhoneNumber(value, "GB");
};
